import { render, staticRenderFns } from "./PersonCallback.vue?vue&type=template&id=30f6247b&"
import script from "./PersonCallback.vue?vue&type=script&lang=ts&"
export * from "./PersonCallback.vue?vue&type=script&lang=ts&"
import style0 from "./PersonCallback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports